import { Link } from "react-router-dom";
import Logo from "./atoms/Logo";

// Two-column shell shared by Login, Signup, ForgotPassword.
// Form on the left, paper-deep editorial panel with an italic quote on the right (≥md).

export default function AuthShell({ children, quote, attribution }) {
  return (
    <div style={{ minHeight: "100vh", background: "var(--paper)" }}>
      <header
        style={{
          padding: "20px 24px",
          maxWidth: 1200,
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link to="/" style={{ textDecoration: "none" }}>
          <Logo />
        </Link>
        <Link to="/" style={{ color: "var(--fg-3)", fontSize: 13, textDecoration: "none" }}>
          ← Back to home
        </Link>
      </header>

      <div
        className="grid"
        style={{
          maxWidth: 1080,
          margin: "0 auto",
          padding: "32px 24px 96px",
          gap: 48,
          gridTemplateColumns: "1fr",
          alignItems: "stretch",
        }}
      >
        <div className="auth-grid" style={{ display: "grid", gap: 48, gridTemplateColumns: "1fr", alignItems: "stretch" }}>
          <div style={{ maxWidth: 420, width: "100%", margin: "0 auto" }}>{children}</div>

          {quote && (
            <aside
              className="hidden md:flex"
              style={{
                background: "var(--paper-deep)",
                border: "1px solid var(--border-2)",
                borderRadius: "var(--radius-xl)",
                padding: 48,
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p
                className="font-display"
                style={{
                  fontStyle: "italic",
                  fontSize: "clamp(28px, 3.5vw, 40px)",
                  lineHeight: 1.15,
                  color: "var(--ink-900)",
                  margin: 0,
                  fontWeight: 400,
                }}
              >
                {quote}
              </p>
              {attribution && (
                <p
                  style={{
                    marginTop: 24,
                    fontSize: 13,
                    color: "var(--fg-3)",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.14em",
                  }}
                >
                  — {attribution}
                </p>
              )}
            </aside>
          )}
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .auth-grid { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
    </div>
  );
}
